var map = {
	"./generic-bg--1.jpg": 2082,
	"./generic-bg--10.jpg": 2083,
	"./generic-bg--2.jpg": 2084,
	"./generic-bg--3.jpg": 2085,
	"./generic-bg--4.jpg": 2086,
	"./generic-bg--5.jpg": 2087,
	"./generic-bg--6.jpg": 2088,
	"./generic-bg--7.jpg": 2089,
	"./generic-bg--8.jpg": 2090,
	"./generic-bg--9.jpg": 2091
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2081;